import React from 'react';
import { Card } from '../components/common/UIComponents';
import { PodiumF1 } from '../components/PodiumF1';

export default function PodiumPage() {
  return (
    <div className="p-6 space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Podio en Tiempo Real - Fórmula 1</h1>
          <p className="text-sm text-gray-500">
            Visualice los 10 primeros usuarios con mayor acumulación de puntos en el circuito de estaciones en tiempo real.
          </p>
        </div>
        <div className="flex items-center gap-2 bg-emerald-50 text-emerald-700 text-xs font-bold px-3 py-1.5 rounded-full border border-emerald-200">
          <span className="w-2 h-2 rounded-full bg-emerald-500 animate-ping" />
          Actualización en Vivo
        </div>
      </div>

      <Card>
        <PodiumF1 />
      </Card>
    </div>
  );
}
